export class FlyoutInitializer {
	public init = () => {
		this.toTopButton();
		this.downloadButton();
		this.jobsButton();

		this.handleMobileIcons();
	};

	private handleMobileIcons() {
		const flyoutIcons = document.querySelectorAll<HTMLImageElement>(
			'.flyout-wrapper .flyout-item .image-container img'
		);

		if (window.innerWidth <= 767) {
			flyoutIcons.forEach((icon) => {
				const mobileIcon = icon.getAttribute('data-icon-mobile');
				if (mobileIcon === null) return;

				icon.src = mobileIcon;
			});
		}
	}

	private toTopButton = () => {
		const toTopButton: HTMLButtonElement | null = document.querySelector('.to-top');

		toTopButton?.addEventListener('click', (e) => {
			e.preventDefault();

			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	};

	/**
	 * Scroll downloads into view on click.
	 * Could be done without JS, but this is easier.
	 * Feel free to refactor if this irks you.
	 */
	private downloadButton = () => {
		const downloadAccordion = document.querySelector('.download-accordion');

		// We only show the downloads button if a download section exists on the current side
		if (downloadAccordion == null) return;

		const downloadButton = document.querySelector('.flyout-wrapper .download');

		downloadButton?.classList.remove('hidden');

		downloadButton?.addEventListener('click', (e) => {
			e.preventDefault();

			downloadAccordion.scrollIntoView({ behavior: 'smooth' });
		});
	};

	private jobsButton = () => {
		// We check if the current URL contains 'career' or 'karriere'. Only proceed if it does.
		// TODO: This will not work with the chinese site.
		const href = window.location.href;
		if (!href.includes('career') && !href.includes('karriere')) return;

		// Show jobs button
		const jobsButton = document.querySelector('.flyout-wrapper .jobs');

		jobsButton?.classList.remove('hidden');
	};
}
